import React from 'react';
import { Row, Col } from 'antd';

export default ({ label, value }) => {
    return (<Row className="attribute-row">
        <Col span={11} className="attribute-name">{label}</Col>
        <Col span={2}> : </Col>
        <Col span={11}>{value}</Col>
    </Row>)
}